import i18n from './../../shared/i18n';

import BaseModel from "../../core/components/input-widget/BaseModel";
import moment from "moment";
import {Formatter, SYSTEM_DATE_FORMAT, SYSTEM_TIME_FORMAT} from "@/core/services/formatter.service";

export default class TransferNoteModel extends BaseModel {
  type = 'internal';
  status = 'draft';
  issue_date = Formatter.getNowAsDate();;
  issue_time = '10:00:00';
  arrival_date = null;
  arrival_time = '10:00:00';
  service_provider = null;
  origin_item_location_uuid = null;
  destination_item_location_uuid = null;
  rep_user_uuid = null;
  title = null;
  note = null;
  origin_item_location = null;
  destination_item_location = null;
  transfer_note_items = null;

  constructor(data = {}) {
    super();

    if (data.arrival_date) {
      let arrival_date = data.arrival_date
      data.arrival_date = moment(arrival_date).format(SYSTEM_DATE_FORMAT);
      data.arrival_time = moment(arrival_date).format(SYSTEM_TIME_FORMAT);
    }
    if (data.issue_date) {
      let issue_date = data.issue_date
      data.issue_date = moment(issue_date).format(SYSTEM_DATE_FORMAT);
      data.issue_time = moment(issue_date).format(SYSTEM_TIME_FORMAT);
    }

    Object.assign(this, {...data});
  }

  toJSON() {
    const data = super.toJSON();

    if (data.arrival_date) {
      data.arrival_date = Formatter.getDateAndTimeToSystemFormat(data.arrival_date, data.arrival_time)
    }

    if (data.issue_date) {
      data.issue_date = Formatter.getDateAndTimeToSystemFormat(data.issue_date, data.issue_time)
    }

    delete data.issue_time
    delete data.arrival_time
    delete data.origin_item_location
    delete data.destination_item_location
    delete data.transfer_note_items

    return data
  }

  rules = {
    type: 'required',
    status: 'required'
  };

  attributeHints = {
  };

  attributeLabels = {
    type: i18n.t('Type'),
    status: i18n.t('Status'),
    issue_date: i18n.t('Issue Date'),
    issue_time: i18n.t('Issue Time'),
    arrival_date: i18n.t('Arrival Date'),
    arrival_time: i18n.t('Arrival Time'),
    service_provider: i18n.t('Service Provider'),
    origin_item_location_uuid: i18n.t('Origin Item Location'),
    destination_item_location_uuid: i18n.t('Destination Item Location'),
    rep_user_uuid: i18n.t('Rep. User'),
    title: i18n.t('Title'),
    note: i18n.t('Note'),
  };
}
